import React from 'react';
import moment from 'moment';
import { Col, Row } from 'antd';
import InfoItem from '../../../components/InfoItem';
import CardsList from '../../Cards/components/CardsList';

function returnGenderValue(value) {
  switch (value) {
    case 'm':
      return 'Male';
    case 'f':
      return 'Female';
    case 'u':
      return 'Undisclosed';
  }
}

export default function User({ data }) {
  if (!data) {
    return null;
  }

  const dateOfBirth = moment(data.birthday).format('YYYY-MM-DD');
  const genderValue = returnGenderValue(data.gender);

  return (
    <div className="container">
      <Row gutter={[16, 16]} className="grid-list-ib text-center-xs">
        <Col>
          <div className="gutter-box min-w-340 px-2 py-1">
            <div className="gutter-box p-2">
              <div className="avatar-wrapper m-auto">
                <img src={data.logo} alt="" className="avatar" />
              </div>
            </div>
            <InfoItem label="Date created"
                      value={moment(data.created_at).format('YYYY-MM-DD hh:mm A')} />
            <InfoItem label="First Name" value={data.first_name} />
            <InfoItem label="Last Name" value={data.last_name} />
            <InfoItem label="Email" value={data.email} isTrimmed maxLength={25} notTrimXs />
            <InfoItem label="Phone Number" value={data.phone_number} />
            <InfoItem label="Birthday" value={dateOfBirth} />
            <InfoItem label="Gender" value={genderValue} />
          </div>
        </Col>
        <Col>
          <div className="gutter-box min-w-264 px-2 py-1">
            <InfoItem label="Cards Count"
                      value={data.cards_count}
                      valueSpan={10}
                      labelSpan={14} />
            <InfoItem label="Friends Count"
                      value={data.friends_count}
                      valueSpan={10}
                      labelSpan={14} />
            <InfoItem label="Leader Place"
                      value={data.leader_place}
                      valueSpan={10}
                      labelSpan={14} />
          </div>
        </Col>
      </Row>
      <Row className="mt-2">
        {/*<CardsList cardsArray={cards} total={total} className="grid-list-ib" />*/}
      </Row>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Clients/components/User.js